module.exports = ".row{\r\n    padding: 15px 0px 0px;\r\n}\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/psadetails/psa-list/psa-supervisors/psa-supervisors.component.css
// module id = ./src/app/pages/functions/psadetails/psa-list/psa-supervisors/psa-supervisors.component.css
// module chunks = main